import dashboard from '../frontEnd/de/dashboard.json'
import findProducts from '../frontEnd/de/findProducts.json'
import common from '../frontEnd/de/common.json'
import frameClass from '../frontEnd/de/frameClass.json'
import sourcing from '../frontEnd/de/sourcing.json'
import listProduct from '../frontEnd/de/listProduct.json'
import orders from '../frontEnd/de/orders.json'
import customService from '../frontEnd/de/customService.json'
import siteOptimization from '../frontEnd/de/siteOptimization.json'
import subscribe from '../frontEnd/de/subscribe.json'
import setting from '../frontEnd/de/setting.json'
import shoppingCart from '../frontEnd/de/shoppingCart.json'
import message from '../frontEnd/de/message.json'
import partnership from '../frontEnd/de/partnership.json'

const de =  {
    ...dashboard,
    ...findProducts,
    ...common,
    ...frameClass,
    ...sourcing,
    ...listProduct,
    ...orders,
    ...customService,
    ...siteOptimization,
    ...subscribe,
    ...setting,
    ...shoppingCart,
    ...message,
    ...partnership
};
export default de;